import $ from 'jquery';
import Swiper from 'swiper';
import CatalogService from '../service/CatalogService';
import StoreService from '../service/StoreService';
import CatalogItem from '../template/CatalogItem';
import onDocumentReady from '../util/onDocumentReady';

const sliders = {};

const createSlider = (sliderContainer) => {
    return new Swiper(sliderContainer.find('.swiper-container'), {
        speed: 600,
        spaceBetween: 20,
        slidesPerView: 5,
        slidesPerGroup: 5,
        autoHeight: true,
        pagination: {
            el: sliderContainer.find('.catalog-linked-control__pagination'),
            type: 'fraction',
        },
        navigation: {
            nextEl: sliderContainer.find('.catalog-linked-control__button--next'),
            prevEl: sliderContainer.find('.catalog-linked-control__button--prev'),
        },

        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1023: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            1439: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
        },

    });
};

onDocumentReady(() => {
    $('.catalog-linked').each(function (index) {
        $(this).fadeIn();
        sliders[index] = createSlider($(this));
        return true;
    });
});

const refreshSlider = function (sliderInstance, productIds) {
    const params = {
        limit: 999,
        id: productIds
    };
    CatalogService.getItems(params).then((response) => {
        sliderInstance.removeAllSlides();

        response.items.forEach((item) => {
            sliderInstance.appendSlide(
                CatalogItem({
                    isSlider: true,
                    ...item
                })
            );
        });

        setTimeout(() => {
            sliderInstance.update();
            sliderInstance.slideTo(0);
        }, 2000);
    });
};

StoreService.onChange(() => {
    $('.catalog-linked').each(function (index) {
        refreshSlider(sliders[index], JSON.parse($(this).attr('data-products')));
    });
});
